import { type Copy } from "./types";

export type SectionHead = {
  readonly eyebrow: string;
  readonly title: string;
  readonly lede: Copy;
};

export const HOW_HEAD: SectionHead = {
  eyebrow: "The workflow",
  title: "How it works",
  lede: [
    "Every design automatically generates its knitting logic, diagnostics, and manufacturable outputs. LOOP brings the knowledge of experienced knit engineers directly into the workflow, carrying design intent from a file on your desktop to production-ready knit data in four steps.",
  ],
};

export const APPLICATIONS_HEAD: SectionHead = {
  eyebrow: "Applications",
  title: "Or start from an example",
  lede: ["Every project below is a real LOOP file."],
};

export const SHIFT_HEAD: SectionHead = {
  eyebrow: "Platform",
  title: "The Shift",
  lede: [
    "LOOP brings design, knit engineering and production into one connected workflow — extending expert capability instead of replacing it.",
  ],
};

export const COST_HEAD: SectionHead = {
  eyebrow: "The cost of delay",
  title: "The old way isn't free",
  lede: [
    "Traditional knit development relies on close coordination between designers, programmers and manufacturing partners. LOOP brings more of that process into a shared digital workflow.",
  ],
};
